module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    on: {
      "click": function($event) {
        return _vm.goRout(0)
      }
    }
  }, [_c('span', {
    staticClass: "span span0",
    class: _vm.navIndex == 0 ? "checked-span0" : ""
  }, [(_vm.messageCount != 0 && _vm.messageCount != "undefined") ? _c('i', [_vm._v(_vm._s(_vm.messageCount))]) : _vm._e()]), _c('span', {
    class: _vm.navIndex == 0 ? "checked" : ""
  }, [_vm._v("待处理")])]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.goRout(1)
      }
    }
  }, [_c('span', {
    staticClass: "span span1",
    class: _vm.navIndex == 1 ? "checked-span1" : ""
  }, [(_vm.messageCount2 != 0 && _vm.messageCount2 != "undefined") ? _c('i', [_vm._v(_vm._s(_vm.messageCount2))]) : _vm._e()]), _c('span', {
    class: _vm.navIndex == 1 ? "checked" : ""
  }, [_vm._v("抄送我")])]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.goRout(2)
      }
    }
  }, [_c('span', {
    staticClass: "span span2",
    class: _vm.navIndex == 2 ? "checked-span2" : ""
  }), _c('span', {
    class: _vm.navIndex == 2 ? "checked" : ""
  }, [_vm._v("我的")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbfdcf54"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/appNav.vue
// module id = 1687
// module chunks = 471